<template>
  <Page :pagination="pagination">
    <template #content>
      <p class="page-title">Résultats du profil</p>
      <ProgressCircular
        :value="candidate.results.compatibility"
        data-convert="compatibility"
      />
      <p class="appreciation">
        Cette valeur est calculée sur la base de la pondération que vous avez
        configurée lors de votre export.
      </p>
      <div class="recap" data-convert="result_tags">
        <p class="bold">Détail de la notation :</p>
        <div class="notes">
          <div v-for="skill in modules" :key="skill.id" class="note">
            <span
              class="skill-notation"
              :class="candidate.results[getId(skill)].rank"
              v-text="candidate.results[getId(skill)].rank"
            />
            {{ skill.name }}
          </div>
        </div>
      </div>
      <Toast
        title="Pour rappel :"
        text="L’évaluation des talents avec cette analyse ne remplace pas un processus complet, avec entretiens."
        color="yellow"
        icon="bi-info-circle"
        :closable="false"
      />
    </template>
  </Page>
</template>

<script setup>
import Page from "../Page.vue";
import { useCampaignStore } from "@/stores/campaign.js";

const { currentCampaign } = useCampaignStore();

const props = defineProps({
  pagination: {
    type: String,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  modules: {
    type: Array,
    required: true,
  },
});

function getId(skill) {
  if (currentCampaign.version === 1) {
    return skill.id;
  }

  return Object.keys(props.candidate.results).find(
    (key) => key.includes(skill.id_v2) || key.includes(skill.id)
  );
}
</script>
